export const Config = {
  unconfirmedReportsViolationCount: 2,
  unconfirmedReportsViolationMonths: 1,
  reloadTimeoutOnExpiredToken: 3,
  forumUrl: process.env.VUE_APP_FORUM_URL,
  tournamentApiEndpoint: process.env.VUE_APP_TOURNAMENT_API_ENDPOINT,
  translationsApiEndpoint: process.env.VUE_APP_TRANSLATIONS_API_ENDPOINT,
  ratingApiEndpoint: process.env.VUE_APP_RATING_API_ENDPOINT,
};
